const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://academy.viture.com',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo: 'https://s1.viture.com/viture_com/images/viture-logo.svg',
    logoLink: 'https://www.viture.com/',
    title:
      "",
    githubUrl: '',
    helpUrl: '',
    tweetText: '',
    social: ``,
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [],
    collapsedNav: [],
    links: [],
    frontLine: false,
    ignoreIndex: true,
    title: "",
  },
  siteMetadata: {
    title: 'VITURE Academy',
    description: 'VITURE Academy',
    ogImage: '/viture-og.jpg',
    docsLocation: 'https://academy.viture.com',
    favicon: '/favicon.png',
  },
  pwa: {
    enabled: false,
    manifest: {
      name: 'VITURE Academy',
      short_name: 'VITURE Academy',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
